import { emit } from '@/neon/events';

const selectors = {
  form: '.selectors-form',
  disclosureList: '[data-disclosure-list]',
  disclosureToggle: '[data-disclosure-toggle]',
  disclosureInput: '[data-disclosure-input]',
  disclosureOptions: '[data-disclosure-option]',
};

const classes = {
  listVisible: 'disclosure-list--visible',
};

function has(list, selector) {
  return list.map(l => l.contains(selector)).filter(Boolean);
}

const disclosure = (node, container) => {
  const form = container.querySelector(selectors.form);
  const disclosureList = node.querySelector(selectors.disclosureList);
  const disclosureToggle = node.querySelector(selectors.disclosureToggle);
  const disclosureInput = node.querySelector(selectors.disclosureInput);
  const disclosureOptions = node.querySelectorAll(selectors.disclosureOptions);

  disclosureOptions.forEach(option =>
    option.addEventListener('click', submitForm)
  );

  disclosureToggle.addEventListener('click', handleToggle);
  disclosureToggle.addEventListener('focusout', handleToggleFocusOut);
  disclosureList.addEventListener('focusout', handleListFocusOut);
  node.addEventListener('keyup', handleKeyup);
  document.addEventListener('click', handleBodyClick);

  function submitForm(evt) {
    evt.preventDefault();
    const { value } = evt.currentTarget.dataset;

    disclosureInput.value = value;
    form.submit();
  }

  function handleToggleFocusOut(evt) {
    const disclosureLostFocus = has([node], evt.relatedTarget).length === 0;

    if (disclosureLostFocus) {
      hideList();
    }
  }

  function handleListFocusOut(evt) {
    const childInFocus = has([node], evt.relatedTarget).length > 0;
    const isVisible = disclosureList.classList.contains(classes.listVisible);

    if (isVisible && !childInFocus) {
      hideList();
    }
  }

  function handleKeyup(evt) {
    if (evt.which !== 27) return;
    hideList();
    disclosureToggle.focus();
  }

  function handleToggle(evt) {
    disclosureList.classList.toggle(classes.listVisible);
    const ariaExpanded = disclosureList.classList.contains(classes.listVisible);

    evt.currentTarget.setAttribute('aria-expanded', ariaExpanded);

    if (ariaExpanded) {
      emit('navitem:closeOthers');
    }
  }

  function handleBodyClick(evt) {
    const isOption = has([node], evt.target).length > 0;
    const isVisible = disclosureList.classList.contains(classes.listVisible);

    if (isVisible && !isOption) {
      hideList();
    }
  }

  function hideList() {
    disclosureToggle.setAttribute('aria-expanded', false);
    disclosureList.classList.remove(classes.listVisible);
  }

  const unload = () => {
    disclosureOptions.forEach(o => o.removeEventListener('click', submitForm));
    disclosureToggle.removeEventListener('click', handleToggle);
    disclosureToggle.removeEventListener('focusout', handleToggleFocusOut);
    disclosureList.removeEventListener('focusout', handleListFocusOut);
    node.removeEventListener('keyup', handleKeyup);
    document.removeEventListener('click', handleBodyClick);
  };

  return { unload, hideList };
};

export default disclosure;
